import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { SignInFormPatientProviderMode } from '@zocdoc-frontend-common/components-sign-in-form/components/SignInFormPatientProviderMode';
import {
    columnOffset,
    columnSize,
    Column,
    Row,
} from '@zocdoc-frontend-common/styles-grid';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

/**
 * @param {string} appleLoginUrl
 * @param {string} facebookLoginUrl
 * @param {string} forgotPasswordLinkTarget
 * @param {string} googleLoginUrl
 * @param {function(): void} onClickCreateAccount
 * @param {string} pageTitle
 * @param {string} returnUrl
 * @param {boolean} showAppleLoginButton
 * @param {boolean} showFacebookLoginButton
 * @param {boolean} showGoogleLoginButton
 * @param {boolean} showRememberMe
 * @param {string} signInEndpoint
 * @returns {JSX.Element}
 * @constructor
 */
class BaseSignInPageControlView extends PureComponent {
    render() {
        const {
            facebookLoginUrl,
            forgotPasswordLinkTarget,
            googleLoginUrl,
            appleLoginUrl,
            onClickCreateAccount,
            pageTitle,
            returnUrl,
            showFacebookLoginButton,
            showGoogleLoginButton,
            showAppleLoginButton,
            showRememberMe,
            signInEndpoint,
        } = this.props;

        const props = {
            allowToggle: false,
            autoFocusEmailField: true,
            facebookLoginUrl,
            forgotPasswordLinkTarget,
            googleLoginUrl,
            appleLoginUrl,
            onClickCreateAccount,
            returnUrl,
            showFacebookLogin: showFacebookLoginButton,
            showGoogleLogin: showGoogleLoginButton,
            showAppleLogin: showAppleLoginButton,
            showRememberMe,
            url: signInEndpoint,
        };

        return (
            <Wrapper>
                <Row>
                    <Title data-test="title-message">{pageTitle}</Title>
                </Row>
                <Row>
                    <StyledSignInForm {...props} />
                </Row>
            </Wrapper>
        );
    }
}

const Wrapper = styled(Column)`
    margin: 0 auto;
    max-width: 1024px;
    ${columnSize(22)};
    ${columnOffset(1)};

    ${breakpoint.small} {
        ${columnSize(12)};
    }
`;

const Title = styled(Column).attrs({ size: 24 })`
    font: 24px/24px ${FontFamily.SharpSansBold};
    margin-bottom: 28px;
    padding-top: 20px;
    text-align: center;

    ${breakpoint.small} {
        font-size: 24px;
        margin-bottom: 32px;
        padding: 0;
    }
`;

const StyledSignInForm = styled(SignInFormPatientProviderMode)`
    text-align: left;
`;

export default BaseSignInPageControlView;
